exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".src-components-data-bank-dataset-detail-content-___content__container___1DAEk {\n  display: flex;\n  flex: 1;\n}", ""]);

// exports
exports.locals = {
	"container": "src-components-data-bank-dataset-detail-content-___content__container___1DAEk"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?modules&importLoaders=1&localIdentName=[path]___[name]__[local]___[hash:base64:5]!./~/resolve-url-loader!./~/sass-loader!./src/components/data-bank/dataset-detail/content/content.scss
// module id = 2258
// module chunks = 0